import React from "react";
import '../css/education.css';

function Education(){
    return (
        <div className="education-entry">
            <div className="education-info">
                <h3>Servicio Nacional de Aprendizaje SENA</h3>
                <p className="degree">Software development technician</p>
                <p className="location">Location: Medellin, Antioquia</p>
                <p className="website">Website: <a href="https://www.sena.edu.co/es-co/Paginas/default.aspx" target="_blank" rel="noopener noreferrer">https://www.sena.edu.co/es-co/Paginas/default.aspx</a></p>
                <p className="skills">knowledge:
                    <ul>
                        <li>Programmation logic.</li>
                        <li>Algorithms and data structures</li>
                        <li>Problem solving ability.</li>
                        <li>Gathering of user requirements.</li>
                        <li>Project documentation.</li>
                        <li>Technologies oriented to the frontend and backend.</li>
                        <li>HTML, CSS, php, javascript, python and sql languages.</li>
                        <li>Carrying out CRUD (Create, Read, Update, Delete) in the PHP language.</li>
                        <li>Database modeling.</li>
                        <li>Database MySQL.</li>
                    </ul>
                </p>
            </div>
            <div class="education-image">
                <img src={require('../img/sena.jpg')} alt="Institución" />
            </div>
        </div>
    );
}

export default Education;